import React from 'react';
import classes from "./Textarea.module.scss";

export const Textarea = ({ type, placeholder, name, value, onChange, idx }) => {
    return (
        <textarea type={type} placeholder={placeholder} className={classes.Textarea} value={value} name={name} data-idx={idx} onChange={(event) => onChange(event)}/>
    )
}